export default __webpack_public_path__ + "static/media/bioplastic.bd2c546b.svg";